import CartMenu from "./cart-menu.vue";

const promise = new Promise(resolve => {
  vueApp.component('cart-menu', CartMenu);
  resolve();
});

window.pendingComponentLoads.push(promise);